export enum ActivityType {
  ACTIVITY = 'activity',
}


export enum ActivityAction {

  UPDATE_USER_DATA = 'update_user_data',
  ADD_WEBSITE = 'add_website',
  CREATE_WEBSITE = 'create_website',
  CREATE_STAGING_WEBSITE = 'staging_website_create',
  PUSH_TO_LIVE = 'push_to_live',
  PUSH_TO_STAGING = 'push_to_staging',
  DELETE_STAGING_WEBSITE = 'staging_website_delete',
  GENERATE_WEBSITE_SCREENSHOT = 'generate_website_screenshot',
  CLIENT_LOGOUT = 'client_logout',
  CLIENT_LOGOUT_EXCEPT_CURRENT_SESSION = 'client_logout_except_current_session',
  REMOVE_WEBSITE = 'remove_website',
  DEACTIVATE_WEBSITE = 'deactivate_website',
  MIGRATE_WEBSITE = 'migrate_website',
  UPDATE_WEBSITE_WORDPRESS_VERSION = 'wp_core_update',
  OPTIMIZING_FIRST_PAGE = 'first_page_is_optimizing',
  OPTIMIZING_CUSTOM_PAGE = 'custom_page_is_optimizing',
  INSTALL = 'install',
  INSTALL_ACTIVATE = 'install_activate',
  INSTALL_ACTIVATE_UPLOAD = 'install-activate',
  UPDATE = 'update',
  DELETE = 'delete',
  DEACTIVATE_DELETE = 'deactivate_delete',
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  RUN_JOB = 'run_job',
  BACKUP = 'backup',
  RESTORE = 'restore',
  PROCESS_DOWNLOAD = 'process_download',
  OPTIMIZE = 'optimize',
  IO_OPTIMIZING_CUSTOM_PAGE = 'io_custom_page_is_optimizing',
  PERFORMANCE_CHECK = 'performance_check',
  IMPORT_TEMPLATE = 'install_template',
  IMPORT_HOSTED_TEMPLATE = 'install_hosted_template',
  SECURITY_SCAN = 'run_scan',
  AI_CREATE_WEBSITE = 'ai_create_website',
  PERFORMANCE_GOOGLE_SCORE = 'page_speed_score',
  WORKSPACE_ROLE_EDIT = 'workspace_role_edit',
  WORKSPACE_LEAVE = 'workspace_leave',
  WORKSPACE_CLIENT_REMOVE = 'workspace_client_remove',
  WORKSPACE_SWITCH = 'workspace_switch',
  AGREEMENT_UPGRADE = 'agreement_upgrade',
  AGREEMENT_RENEW = 'agreement_renew',
  AGREEMENT_ACTIVATE = 'agreement_activate',
  WORKSPACE_INVITATION_ACCEPT = 'workspace_invitation_accept',

  AI_GENERATE_WEBSITE = 'ai_generate_website',
  INSTALL_HOSTED_TEMPLATE = 'install_hosted_template',
  BUILDER_GET_OUTLINE = 'get_outline',
  BUILDER_SECTION_TYPES = 'section_types',
  BUILDER_SECTION_ENHANCE = 'section_enhance',
  BUILDER_SECTION_GENERATE = 'section_generate',
  PRODUCTS_GENERATE = 'ecom_data',
  BUILDER_SECONDARY_PAGE = 'build_secondary_page',
  BUILDER_SECTION_SUGGEST_TITLE = 'section_suggest_title',
  BUILDER_SECTION_SUGGEST_DESCRIPTION = 'section_suggest_description',
  BUILDER_STYLES = 'styles',
  BUILDER_COLORS = 'colors_modify',
  BUILDER_TEMPLATE_FROM_OUTLINE = 'template_from_outline',
  BUILDER_BUILD_SITE_OUTLINE = 'build_site_from_outline',
  BUILDER_BUILD_SITE_DESC = 'build_site_from_description',
  CREATE_DEDICATED_INSTANCE = 'create_dedicated_instance',
  SSL_CERTIFICATE_GENERATION = 'generate_ssl_api_reseller',
}

export enum ActivityStatus {

  PENDING = 'pending',
  RUNNING = 'running',
  DONE = 'done',
  SUCCESS = 'success',
  FAILED = 'failed',
  CANCELED = 'canceled'

}

export interface IActivity {

  id: string;
  websiteId: number;
  service: string;
  type: string;
  action: string;
  date: Date;
  status: string;
  progress: number;
  message: string;
  meta: any;
  meta_data?: any;
  workspace_id?: any;
  migrating_domain_id: any;

  finished: boolean;

}
